/**
 * Enum for tooltip align types
 * @name TooltipAlignType
 */
export var TooltipAlignType;
(function (TooltipAlignType) {
    TooltipAlignType["TOP"] = "top";
    TooltipAlignType["RIGHT"] = "right";
    TooltipAlignType["BOTTOM"] = "bottom";
    TooltipAlignType["LEFT"] = "left";
})(TooltipAlignType || (TooltipAlignType = {}));
//# sourceMappingURL=tooltipAlign.js.map